import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/leadFunctions/leadAttachmentActions'
import * as api from '../../api/lead/attachments'

function* leadAttachmentsRefresh(action) {
  try {
    const payload = yield call(api.getLeadAttachments, action.leadId)
    yield put({ type: constants.LEAD_ATTACHMENTS_REFRESH.SUCCESS, payload })

    action.next && action.next(null, payload)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_ATTACHMENTS_REFRESH.FAILED,
      message: e.message || e
    })

    action.next && action.next(e)
  }
}
function* watchLeadAttachments() {
  yield takeLatest(constants.LEAD_ATTACHMENTS_REFRESH.ACTION, leadAttachmentsRefresh)
}

function* sagaCreateLeadAttachment(action) {
  try {
    const payload = {
      lead_id: action.leadId,
      content: action.content,
      file: action.file,
      filename: action.filename,
      created_by_id: action.userId,
      updated_by_id: action.userId
    }

    yield call(api.createLeadAttachment, payload)
    yield put({ type: constants.LEAD_ATTACHMENT_CREATE.SUCCESS, payload })
    yield call(leadAttachmentsRefresh, { leadId: action.leadId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_ATTACHMENT_CREATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateLeadAttachment() {
  yield takeLatest(constants.LEAD_ATTACHMENT_CREATE.ACTION, sagaCreateLeadAttachment)
}

function* sagaUpdateLeadAttachment(action) {
  try {
    const payload = {
      description: action.description,
      attachment_id: action.attachmentId,
      updated_by_id: action.userId
    }
    yield call(api.updateLeadAttachment, payload)
    yield put({ type: constants.LEAD_ATTACHMENT_UPDATE.SUCCESS, payload })
    yield call(leadAttachmentsRefresh, { leadId: action.leadId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_ATTACHMENT_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateLeadAttachment() {
  yield takeLatest(constants.LEAD_ATTACHMENT_UPDATE.ACTION, sagaUpdateLeadAttachment)
}

function* sagaDeleteLeadAttachment(action) {
  try {
    const payload = {
      attachment_id: action.attachmentId
    }
    yield call(api.deleteLeadAttachment, payload)
    yield put({ type: constants.LEAD_ATTACHMENT_DELETE.SUCCESS, payload })
    yield call(leadAttachmentsRefresh, { leadId: action.leadId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_ATTACHMENT_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteLeadAttachment() {
  yield takeLatest(constants.LEAD_ATTACHMENT_DELETE.ACTION, sagaDeleteLeadAttachment)
}

function* getLeadAttachments(action) {
  try {
    const payload = yield call(api.getLeadAttachments, {
      lead_id: action.leadId,
      attachment_id: action.attachmentId,
      type: 'lead'
    })
    yield put({ type: constants.GET_LEAD_ATTACHMENTS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_LEAD_ATTACHMENTS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetLeadAttachments() {
  yield takeLatest(constants.GET_LEAD_ATTACHMENTS.ACTION, getLeadAttachments)
}

export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchLeadAttachments),

    fork(watchCreateLeadAttachment),
    fork(watchUpdateLeadAttachment),
    fork(watchDeleteLeadAttachment),

    fork(watchGetLeadAttachments)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/leadFunctions/leadAttachmentSaga.js